import React, { useState } from "react";
import Box from "@mui/material/Box";

/**
 * The ribbon in the corner of the top bar (styles: .NavBrand in Navbar.scss).
 *
 * Its light crosses left to right by itself, every few seconds, in CSS (the time is in Navbar.scss), and nothing interrupts
 * it. Moving the mouse onto the
 * ribbon sends a second light across, right to left, once. That one always finishes, even if the mouse leaves at once,
 * which is why it is a class set here and not a :hover rule: a :hover animation stops dead when the mouse leaves.
 */
const BrandRibbon = ({ brand, phone = false, sx, children }) => {
  const [goingBack, setGoingBack] = useState(false);

  return (
    <Box
      component="span"
      className={`NavBrand${phone ? " NavBrand--phone" : ""} NavBrand--${brand.key}`}
      sx={sx}
      onMouseEnter={() => setGoingBack(true)}>
      <span
        className={`NavBrand__shine${goingBack ? " NavBrand__shine--back" : ""}`}
        onAnimationEnd={() => setGoingBack(false)}
      />
      {children}
    </Box>
  );
};

export default BrandRibbon;
